<template>
    <div class="as-schematic-item">
        <div class="as-schematic-item__body">
            <div class="as-schematic-player as-schematic-player__home">
                <div class="as-schematic-info">
                    <img v-if="!isNull" class="as-schematic-info__img"
                        :src="getImgUrlBySport('player', '4wyrn1tvowkq86p', true, 'basketball')" />
                    <div v-if="isNull" class="as-schematic-info__imgNull">

                    </div>
                    <div class="as-schematic-info__name" :class="{'isNull' : isNull}">
                        {{ isNull ? '-' : 'Elias G.' }}
                    </div>
                </div>
                <div class="as-schematic-score" :class="{'isNull' : isNull}">
                    <span>{{ isNull ? '-' : 0 }}</span>
                </div>
            </div>
            <div class="as-schematic-player as-schematic-player__away">
                <div class="as-schematic-info">
                    <img v-if="!isNull" class="as-schematic-info__img"
                        :src="getImgUrlBySport('player', '4wyrn1tvowkq86p', true, 'basketball')" />
                    <div v-if="isNull" class="as-schematic-info__imgNull">

                    </div>
                    <div class="as-schematic-info__name" :class="{'isNull' : isNull}">
                        {{ isNull ? '-' : 'Elias G.' }}
                    </div>
                </div>
                <div class="as-schematic-score" :class="{'isNull' : isNull}">
                    <span>{{ isNull ? '-' : 0 }}</span>
                </div>
            </div>
        </div>
    </div>
</template>
<script setup lang="ts">
import { defineProps, ref, computed } from "vue";
interface IProps {
    isNull: boolean;
  }

const props = withDefaults(defineProps<IProps>(), {
    isNull: false
});

</script>

<script lang="ts">
export default {};
</script>
